import React from 'react';
import { cn } from '@/lib/cn';
import { IconChevronRight } from '@repo/svgs';

export interface SpecialGemCardProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  /** The main title text */
  title: string;
  /** The description text */
  description: string;
}

export function SpecialGemCard({
  icon,
  title,
  description,
  className,
  ...props
}: SpecialGemCardProps) {
  return (
    <div
      className={cn(
        'bg-primary border border-secondary rounded-2xl p-4 transition-colors duration-200',
        'cursor-pointer hover:bg-primary-hover shadow',
        className,
      )}
      {...props}
    >
      {/* Mobile: Horizontal layout, Desktop: Vertical layout */}
      <div className="flex gap-3 md:flex-col md:gap-2 items-start w-full">
        {/* Icon - 32px */}
        {icon ? <div className="w-8 h-8 flex-shrink-0 text-primary">{icon}</div> : null}

        {/* Content Container */}
        <div className="flex flex-col gap-1 items-start w-full min-w-0">
          {/* Title Container with Chevron */}
          <div className="flex items-center gap-1 w-full">
            {/* Title - Body 1 High Emphasis */}
            <h3 className="text-body-1-high text-primary">{title}</h3>

            {/* Chevron Icon - 16px */}
            <div className="w-4 h-4 flex-shrink-0 text-primary">
              <IconChevronRight className="w-full h-full" />
            </div>
          </div>

          {/* Description - Body 2 */}
          <p className="text-body-2 text-secondary w-full">{description}</p>
        </div>
      </div>
    </div>
  );
}
